import {
  DialogPositionStrategyInIframe,
  ENVIRONMENTS,
  RETAILERS,
} from '@shared/constants';
import { Environment } from '@shared/models';

export const environment: Environment = {
  lang: 'en-US',
  maxReward: 10000,
  production: true,
  maintenance: false,
  hasCampaignBis: false,
  baseHref: '/en/',
  maxSelectedChallenges: 10,
  env: ENVIRONMENTS.STAGING,
  retailerName: RETAILERS.SHANE,
  projectType: 'loyaltyChallenge',
  backendUrl: 'https://b2c.collectors-more.ai.eagleeye.com/api/v2',
  dialogPositionStrategyInIframe: DialogPositionStrategyInIframe.DEFAULT,
  enableSentry: true,
  enableABTest: true,
  ssrAllowedHosts: ['*.uat.ai.eagleeye.com'],
};
